import { Button } from "@/components/ui/button";
import { STATIC_DEMO_MESSAGES } from "@/lib/ui-labels";

const BAR_CLASSES =
  "grid grid-cols-[1fr_auto] items-center gap-x-3 gap-y-1 border-b border-border bg-muted/40 px-4 py-1.5 text-sm sm:flex sm:gap-3";
const BACK_LINK_CLASSES =
  "inline-flex min-h-9 items-center text-muted-foreground transition-colors hover:text-foreground";
const NOTICE_CLASSES =
  "col-span-2 row-start-2 flex items-start gap-2 text-xs text-muted-foreground sm:flex-1 sm:text-sm";
const BADGE_CLASSES =
  "-my-0.5 shrink-0 rounded-full border border-border bg-background px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide";
const ACTIONS_CLASSES = "col-start-2 row-start-1 flex items-center gap-2";

function BackLink() {
  return (
    <a href={STATIC_DEMO_MESSAGES.landingPageUrl} className={BACK_LINK_CLASSES}>
      {STATIC_DEMO_MESSAGES.landingPageLinkText}
    </a>
  );
}

function DemoNotice() {
  return (
    <p className={NOTICE_CLASSES}>
      <span className={BADGE_CLASSES}>{STATIC_DEMO_MESSAGES.demoBadge}</span>
      {STATIC_DEMO_MESSAGES.bannerText}
    </p>
  );
}

function BookMeetingButton() {
  return (
    <Button size="sm" variant="outline" className="hidden sm:inline-flex" asChild>
      <a href={STATIC_DEMO_MESSAGES.bookAMeetingUrl} target="_blank" rel="noopener noreferrer">
        {STATIC_DEMO_MESSAGES.bookAMeetingLinkText}
      </a>
    </Button>
  );
}

function ContactButton() {
  return (
    <Button size="sm" asChild>
      <a href={STATIC_DEMO_MESSAGES.contactUsUrl}>{STATIC_DEMO_MESSAGES.contactUsLinkText}</a>
    </Button>
  );
}

export function StaticDemoViewOnlyBanner() {
  return (
    <div className={BAR_CLASSES}>
      <BackLink />
      <DemoNotice />
      <div className={ACTIONS_CLASSES}>
        <BookMeetingButton />
        <ContactButton />
      </div>
    </div>
  );
}
